<template>
  <mdb-container fluid>
    <div class="row pt-5 pb-3">
      <div class="col-md-3 mx-auto mb-4">
        <div class="card pt-0 card-cascade narrower">
          <div
            class="view view-cascade gradient-card-header mdb-color lighten-3"
          >
            <h5 class="mb-0 font-weight-bold">سرویس ها</h5>
          </div>

          <div class="card-body">
            <div class="mt-2">
              <small>نوع سرویس :</small>

              <ul class="striped list-unstyled" v-if="serviceTypes != null">
                <li
                  class="hover filter"
                  v-for="serviceType in serviceTypes"
                  v-bind:key="serviceType.ServiceId"
                  v-if="serviceType != null"
                  @click="getserviceType(serviceType)"
                >
                  <span
                    class="badge bg-danger float-left"
                    v-show="serviceType.CountNew > 0"
                    v-text="serviceType.CountNew"
                  ></span>
                  <span
                    class="badge bg-primary"
                    v-text="
                      serviceType.Services ? serviceType.Services.length : 0
                    "
                  ></span
                  >&nbsp;
                  <span v-text="serviceType.Name"></span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              class="btn btn-primary btn-lg btn-block"
              data-toggle="modal"
              data-target="#modal-support"
              @click="newWindowsTicket = true"
            >
              <i class="fas fa-plus left"></i> سرویس جدید
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-8 mx-auto white z-depth-1 mb-4">
        <div class="row">
          <div class="col-sm-6 col-md-9 py-4 px-3">
            <h4 class="h4-responsive">سرویس های {{ serviceType.Name }}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 pb-3">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>شناسه اختصاصی</th>
                    <th>نام</th>
                    <th>وضعیت</th>
                    <th>اعتبار</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="service in serviceType.Services">
                    <tr :key="service.ServiceId"
                      class="hover"
                      @click="setShowDetails(service)">
                      <td v-text="service.ServiceId"></td>
                      <td v-text="service.Name"></td>
                      <td v-text="service.StatusName"></td>
                      <td>
                        <span class="grey-text">
                          <small
                            ><i class="far fa-clock"></i>
                            <span v-text="service.Expiration"></span> </small
                        ></span>
                      </td>
                    </tr>
                    <tr
                      :key="service.ServiceId + 100"
                      class="detail-row"
                      v-show="getShowDetails(service)"
                    >
                      <td colspan="4">
                        <table class="table table-secondary">
                          <tr>
                            <td><strong>وضعیت : </strong></td>
                            <td>{{ service.StatusName }}</td>
                            
                            <td><strong>تمدید خودکار : </strong></td>
                            <td>{{ service.Renewal }}</td>
                          </tr>
                          <tr>
                            <td><strong>تاریخ ثبت : </strong></td>
                            <td>{{ service.Register }}</td>

                            <td><strong>گارانتی|پشتیبانی : </strong></td>
                            <td>{{ service.Guarantee }}</td>
                          </tr>
                          <tr>
                            <td><strong>توضیحات : </strong></td>
                            <td colspan="3">{{ service.Desc }}</td>
                          </tr>

                          
                          <tr v-if="service.Features.length>0">
                            <td colspan="2">
                              <table class="table table-light">
                                <tr v-for="(featur,index) in service.Features" 
                                    :key="featur.FeatureId"
                                    v-if="index%2==0">
                                    <td><span class="fas fa-check text-success">&nbsp;</span> <strong v-text="featur.Key"></strong></td>
                                    <td v-text="featur.Value"></td>
                                </tr> 
                              </table>
                            </td>
                            <td colspan="2">
                              <table class="table table-light">
                                <tr v-for="(featur,index) in service.Features" 
                                    :key="featur.FeatureId"
                                    v-if="index%2==1">
                                    <td><span class="fas fa-check text-success">&nbsp;</span> <strong v-text="featur.Key"></strong></td>
                                    <td v-text="featur.Value"></td>
                                </tr> 
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <!-- <mdb-dropdown dropup>
              <mdb-dropdown-toggle slot="toggle" color="primary"
                >Selected</mdb-dropdown-toggle
              >
              <mdb-dropdown-menu dropup>
                <mdb-dropdown-item>Remove</mdb-dropdown-item>
                <mdb-dropdown-item>Mark as read</mdb-dropdown-item>
                <mdb-dropdown-item>Archive</mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown> -->
          </div>
        </div>
      </div>
    </div>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbIcon,
  mdbInput,
  mdbTextarea,
  mdbBtn,
  mdbSelect,
  mdbFileInput,
  mdbChip,
} from "mdbvue";

import serviceApi from "@/api/serviceApi";

export default {
  name: "Support",
  components: {
    mdbContainer,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbInput,
    mdbTextarea,
    mdbBtn,
    mdbSelect,
    mdbFileInput,
    mdbChip,
  },
  data() {
    return {
      serviceTypes: null,
      serviceType: {},
    };
  },
  methods: {
    getserviceType(serviceType) {
      this.serviceType = serviceType;
    },
    getShowDetails(service){
      // console.log("getshowDetails",service);
      if(service.detail == null){
        // service.detail = false;
        this.$set(service, 'detail', false);
      }else{
        return service.detail;
      }
    },
    setShowDetails(service){
      // console.log("setShowDetails",service);
      if(service.detail == null){
        // service.detail = true;
        this.$set(service, 'detail', false);
      }else{
        service.detail = !service.detail;
      }
    }
  },
  mounted() {
    console.log("mounted");
    let serviceId = this.$route.params.serviceId;
    // console.log("serviceId",serviceId);

    this.serviceTypes = this.$store.state.serviceType;

    serviceApi.getServices().then(
      ({ data }) => {
        this.$store.state.serviceType = data;
        this.serviceTypes = this.$store.state.serviceType;
        
        
        if(serviceId != undefined){
          data.forEach(serviceType => {
              serviceType.Services.forEach(service => {
                if(service.ServiceId == serviceId){
                  this.getserviceType(serviceType);
                  this.$set(service, 'detail', true);
                  return;
                }
              });
            });
        }else{
          this.getserviceType(this.serviceTypes[0]);

        }
      },
      (r) => {}
    );
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1.1rem 1rem;
}

.card.card-cascade .view {
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2), 0 2px 8px 0 rgba(0, 0, 0, 0.19);
}
</style>
